const PATIENT_ALERT_ADDITIONAL_DATA_KEYS = {
  suggestedFollowUpDate: 'suggestedFollowUpDate',
} as const;

export default PATIENT_ALERT_ADDITIONAL_DATA_KEYS;
